





















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import { AdminUserRoutes } from '@/modules/user/routes/admin-user.route'


@Component({
  inheritAttrs: false,
  components: { BaseButton, Modal, Toggle, Checkbox, Radio }
})
export default class AdminUserSwitchButton extends Vue {

  constructor(
    private readonly routes: AdminUserRoutes
  ) {
    super()
  }

  @Prop({ required: true }) userId!: number
  @Prop() label!: string
  @Prop() color!: string

}
